import { _Config } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
export const useVideoContent = (packagesM) => {
    const [configM] = useGlobalState(_Config);
    const premiumPackagesM = M.chain((x) => x.premiumPackages, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const videoPackages = M.fromMaybe(packagesM, []);
    const isPremiumContent = JSON.stringify(videoPackages) === JSON.stringify(premiumPackages);
    const shareUrl = config.shareBaseURL; // TODO: Remove in lates stage
    return { isPremiumContent, shareUrl };
};

